import React from 'react';
import './MainResult.css';

const CategoryNavMobile = ({ categories, selectedCategory, onCategorySelect }) => {
  return (
    <div className="result-header mobile">
      <div className="header-nav mobile">
        {categories.map((category, index) => (
          <div
            key={category.name}
            className={`nav-item ${category.active ? 'active' : ''} mobile`}
            onClick={() => onCategorySelect(index)}
          >
            {category.name && <span className="nav-name">↗ {category.name}</span>}
          </div>
        ))}
      </div>
    </div>
  );
};

export default CategoryNavMobile;

